module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-spinner"
  }, [_c('div', {
    staticClass: "loading-bounce"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-bounce"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-bounce"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23f03da6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23f03da6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LxmLoading.vue
// module id = 826
// module chunks = 0